// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".paper-share-page-wrapper .el-scrollbar .el-scrollbar__bar{display:none!important}.paper-share-page-wrapper .el-carousel{width:600px;margin-left:calc(50vw - 315px)}.paper-share-page-wrapper .el-carousel .el-carousel__item{width:280px;background-color:#999;height:380px}.paper-share-page-wrapper .el-carousel .el-carousel__item.is-active{margin:0 auto;z-index:999}", ""]);
// Exports
module.exports = exports;
